"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ParamsValidator =
/*#__PURE__*/
function () {
  function ParamsValidator() {
    _classCallCheck(this, ParamsValidator);
  }

  _createClass(ParamsValidator, null, [{
    key: "isValid",
    value: function isValid(params, schema) {
      var isValid = true;
      Object.keys(schema).forEach(function (key) {
        var schemaEntry = schema[key];
        var param = params[key];

        if (schemaEntry.required && typeof param === 'undefined') {
          isValid = false;
        }

        if (typeof param !== 'undefined') {
          if (schemaEntry.type === 'int' && !ParamsValidator.isInteger(param)) {
            isValid = false;
          } else if (schemaEntry.type === 'intArray') {
            if (!(param instanceof Array)) {
              isValid = false;
            } else {
              param.forEach(function (subParam) {
                if (!ParamsValidator.isInteger(subParam)) {
                  isValid = false;
                }
              });
            }
          }
        }
      });
      Object.keys(params).forEach(function (key) {
        if (typeof schema[key] === 'undefined') {
          isValid = false;
        }
      });
      return isValid;
    }
  }, {
    key: "isInteger",
    value: function isInteger(value) {
      return value === parseInt(value, 10);
    }
  }]);

  return ParamsValidator;
}();

var _default = ParamsValidator;
exports["default"] = _default;